<template>
  <b-modal
    :id="id"
    v-model="localShow"
    title="Connessa - Teleconsulto"
    hide-footer
    centered
    size="lg"
  >
    <div class="p-3">
      <p class="mb-3">
        <strong>Connessa</strong> è il servizio di DottorFARMA che ti permette un video consulto per comunicare con la tua farmacia di fiducia, grazie a una connessione sicura e affidabile.
      </p>
      <p class="mb-3">
        È possibile prenotare un video consulto con il tuo farmacista, per ottenere tutti i consigli di cui hai bisogno.
      </p>
      <h5 class="mb-3">Come funziona?</h5>
      <p class="mb-3">
        Prenota il consulto e collegati nel giorno e nell'orario che hai scelto: potrai parlare in sicurezza con il tuo farmacista di fiducia.
      </p>
      <p class="mb-4">
        Se lo desideri, in fase di prenotazione, potrai indicare il motivo del teleconsulto ed eventualmente rispondere ad alcune domande.
      </p>
      <div class="text-center">
        <b-button
          variant="primary"
          class="primary_gradient fw-bolder px-4 py-2 rounded-pill"
          @click="$emit('proceed')"
        >
          Prenota Teleconsulto
        </b-button>
        <b-button
          variant="outline-secondary"
          class="ml-3 px-4 py-2 rounded-pill"
          @click="localShow = false"
        >
          Chiudi
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "TeleconsultoIntroModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "teleconsulto-modal",
    },
  },
  data() {
    return {
      localShow: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localShow = newVal;
    },
    localShow(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped>
</style>

